/**
 * Log a warning message to the console with bootstrap-vue formatting sugar.
 * @param {string} message
 */
function warn(message) {
    console.warn(`[Bootstrap-Vue warn]: ${message}`)
}

export default warn
